import { useContext } from 'react';
import { PartitionContext } from './partitionContext';

export const usePartition = () => useContext(PartitionContext);
